@if (viewInitialized()) {
    <gridstack [options]="gridOptions" class="cipo-bg--primary-50">
        @for (item of headerItems(); track item.id) {
            <gridstack-item [options]="item | gridstackHeaderOptions">
                <div class="aggregate-item">
                    <p class="cipo--text--ellipsed" [title]="item.label | translate">
                        {{ item.label | translate }}
                        <span class="cipo--text-size--md">{{ data()[item.id] | translate }}</span>
                    </p>
                </div>
            </gridstack-item>
        }
    </gridstack>
}
